module.exports = __webpack_public_path__ + "img/11.904f6157.jpg";